import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_CONNECTIONS,
    REQUEST_ADD_CONNECTION,
    REQUEST_UPDATE_CONNECTION,
    REQUEST_REMOVE_CONNECTION,
    REQUEST_SYNC_CONNECTION,
    REQUEST_LIST_CAMERAS,
    REQUEST_SYNC_SELECTED_CAMERAS,
    REQUEST_UPDATE_APP_ID,
    REQUEST_GET_APP_ID,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/genetecMsgDefinitions";
import {
    GenetecPassportHeader,
    GenetecPassportID,
    GenetecConnectionID,
    GenetecCameraSyncRequest,
    GenetecAppIdPayload,
} from "userful-chronos-app-common-js/dist/models/integration/genetec";

import "./genetecMsgReciever";

export const requestListConnections = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_CONNECTIONS);
};

export const requestAddConnection = (payload: GenetecPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_CONNECTION, payload);
};

export const requestUpdateConnection = (payload: GenetecPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_CONNECTION, payload);
};

export const requestRemoveConnection = (payload: GenetecPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_CONNECTION, payload);
};

export const requestSyncConnection = (payload: GenetecPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SYNC_CONNECTION, payload);
};

export const requestListCameras = (payload: GenetecConnectionID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_CAMERAS, payload);
};

export const requestSyncSelectedCameras = (payload: GenetecCameraSyncRequest) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_SYNC_SELECTED_CAMERAS, payload);
};

export const requestUpdateAppId = (payload: GenetecAppIdPayload) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_APP_ID, payload);
};

export const requestGetAppId = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_GET_APP_ID);
};
